/**
 * vote接口
 */
import axios from '../utils/https' // 导入http中创建的axios实例

const vote = {
  // 检查会议状态是否开始投票
  getMeetingState (params) {
    return axios.get('/api/vote/getMeetingState', { params })
  },
  // 根据会议ID获取投票会议信息
  getMeetingVoteInfo (params) {
    return axios.get('/api/vote/getMeetingVoteInfo', { params })
  },
  // 入围投票--获取入围投票信息
  getShortlistedVoteInfo (params) {
    return axios.get('/api/vote/GetShortlistedVoteInfo', { params })
  },
  // 入围投票--保存投票/提交投票
  shortlistedVote (params) {
    return axios.post('/api/vote/ShortlistedVote', params)
  },
  // 排序投票--获取排序投票信息
  getSortVoteInfo (params) {
    return axios.get('/api/vote/GetSortVoteInfo', { params })
  },
  // 排序投票--保存投票/提交投票
  sortVote (params) {
    return axios.post('/api/vote/SortVote', params)
  },
  // 打分投票--获取打分投票信息
  getScoreVoteInfo (params) {
    return axios.get('/api/vote/GetScoreVoteInfo', { params })
  },
  // 打分投票--保存投票/提交投票
  scoreVote (params) {
    return axios.post('/api/vote/ScoreVote', params)
  },
  // 打分投票--获取投票结果信息
  getVoteResult (params) {
    return axios.get('/api/VoteStatistic/GetVoteResult', { params })
  },
  // 入围投屏--获取入围投屏投票列表
  getShortlistedScreenVoteList (params) {
    return axios.get('/api/vote/GetShortlistedScreenVoteList', { params })
  },
  // 入围投屏--主持人控制进入入围投屏
  openShortlistedScreenVote (params) {
    return axios.post('/api/vote/OpenShortlistedScreenVote', params)
  },
  // 入围投屏--打分投票--投票主持人--进入颁奖典礼
  shortlistedScreenVoteAwardCeremony (params) {
    return axios.post('/api/vote/ShortlistedScreenVoteAwardCeremony', params)
  },
  // 大屏幕更新了最新结果，发消息
  shortlistedBigScreenSend (params) {
    return axios.post('/api/vote/ShortlistedBigScreenSend', params)
  },
  // 特等奖跟同组奖项排名
  getShortlistedScreenCompleteResult (params) {
    return axios.get('/api/vote/GetShortlistedScreenCompleteResult', { params })
  }
}

export default vote
